export default __webpack_public_path__ + "static/media/padlock.9e0f4449.svg";